import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=79452ad8&scoped=true&lang=pug&"
import script from "./MainContent.vue?vue&type=script&lang=js&"
export * from "./MainContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79452ad8",
  null
  
)

export default component.exports